import Tradesman from "../components/landing/Tradesman.jsx";
import Comments from "../components/landing/Comments";
import HeaderLanding2 from "../components/landing/HeaderLanding2.jsx";
import SpecialBasketModal from "../components/landing/SpecialBasketModal.jsx";
import SpecialBaskets from "../components/landing/SpecialBaskets.tsx";
import EditSpecialBasketModal from "../components/landing/EditSpecialBasketModal.jsx";
import "../components/landing/landing.scss";
import Caption from "../components/landing/Caption.jsx";
import Formatter from "hoc/Formatter";
import Loader from "utils/Loader";
import { connection } from "../utils/apiConnection.ts";
import { useState, useEffect } from "react";
export default function Landing() {
  const [companies, setCompanies] = useState([]);
  const [userComment, setUserComment] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadPage() {
      await connection("superadminapi/getsuppliers").then((data) => {
        setCompanies(data.data);

        // console.log("companies : ", data.data);
      });
      await connection("api/get_best_comment").then((data) => {
        setUserComment(data.data);
        console.log("userComment: ", userComment);
      });
      setIsLoading(false);
    }
    loadPage();
  }, []);
  return (
    <>
      {isLoading && <Loader />}

      <div className="landing">
        <HeaderLanding2></HeaderLanding2>
        {/* <HeaderLanding></HeaderLanding> */}
        {/* <SpecialBaskets></SpecialBaskets> */}

        <div
          className="tradesman-container"
          // style={{
          //   backgroundColor: "#F1EAE5",
          //   padding: "90px 6% 20px 6%",
          // }}
        >
          <Formatter color="#FF4734" header="همکاران ما">
            <Tradesman
              type="hamkar"
              companies={companies}
              setCompanies={setCompanies}
            />
          </Formatter>
          {/* <Caption title="همکاران ما" captionColor={"#FF4734"} /> */}

          {/* <div>
            <Formatter color="#6134FF" header="نظریات مشتریان">
              <Comments
                userComment={userComment}
                setUserComment={setUserComment}
              ></Comments>
            </Formatter>
          </div> */}
        </div>
      </div>
    </>
  );
}
